<mat-card>
	<mat-card-header>
		<mat-card-title>
			{{title}}
			<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
			<button class="close-button" mat-mini-fab (click)="closeDialog(false)">
				<mat-icon>close</mat-icon>
			</button>
		</mat-card-title>
	</mat-card-header>

	<mat-card-content>
		<mat-accordion *ngIf="students.length > 0" class="margin-top-md">
			<mat-expansion-panel>
				<mat-expansion-panel-header>
					<mat-panel-title> {{studentLength}} Child(ren) selected &nbsp; <mat-icon *ngIf="isLoadingGroup">
							<mat-spinner diameter="20"> </mat-spinner>
						</mat-icon>
					</mat-panel-title>
					<mat-panel-description *ngIf="selectedChildrenFilter">
						Filter:
						{{selectedChildrenTableDataSource?.filteredData?.length === uniqueStudents.length ?
						uniqueStudents.length :
						(selectedChildrenTableDataSource?.filteredData?.length + '/' + uniqueStudents.length)}}
						Child(ren)
					</mat-panel-description>
				</mat-expansion-panel-header>


				<div class="row">
					<mat-form-field class="col-lg-12">
						<mat-label>
							Filter
						</mat-label>
						<input matInput id="filter" name="filter" type="string" [(ngModel)]="selectedChildrenFilter"
							(ngModelChangeDebounced)="setSelectedChildrenFilter();" />
					</mat-form-field>
				</div>

				<div class="table-responsive">
					<mat-table [dataSource]="selectedChildrenTableDataSource" class="mat-elevation-z1" matSort>

						<ng-container matColumnDef="EDIT">
							<mat-header-cell *matHeaderCellDef>
								<button mat-icon-button color="primary" (click)="toggleAllStudents()"
									*ngIf="!hasAtLeastOneStudent()">
									<mat-icon>check_box_outline_blank</mat-icon>
								</button>
								<button mat-icon-button color="primary" (click)="toggleAllStudents()"
									*ngIf="hasAtLeastOneStudent() && hasDifferentCounts()">
									<mat-icon>indeterminate_check_box</mat-icon>
								</button>
								<button mat-icon-button color="primary" (click)="toggleAllStudents()"
									*ngIf="hasAtLeastOneStudent() && !hasDifferentCounts()">
									<mat-icon>check_box</mat-icon>
								</button>
							</mat-header-cell>
							<mat-cell *matCellDef="let element">
								<button mat-icon-button color="primary" (click)="toggleStudent(element)"
									[hidden]="element.ENABLED"
									[ngClass]="{'disabled cursor-default': element.GRADUATED}">
									<mat-icon>check_box_outline_blank</mat-icon>
								</button>
								<button mat-icon-button color="primary" (click)="toggleStudent(element)"
									[hidden]="!element.ENABLED"
									[ngClass]="{'disabled cursor-default': element.GRADUATED}">
									<mat-icon>check_box</mat-icon>
								</button>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="MSD_NUMBER">
							<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
							<mat-cell *matCellDef="let element">
								{{element.MSD_NUMBER}}
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="PERSON.LAST_NAME">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
							<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
								titlecase}}{{(element.SECOND_LAST_NAME
								? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
								titlecase}}
								{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.GRADE}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_TYPE}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_DATE |
									simpleDate}}</div>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.WITHDRAWAL_DATE |
									simpleDate}}</div>
							</mat-cell>
						</ng-container>

						<ng-container
							matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
							<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
							<mat-cell *matCellDef="let element" class="row">
								<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
									{{sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE | simpleDate}}</div>
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row *matRowDef="let row; columns: displayedColumns;"
							[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
							[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
							[matTooltipPosition]="'above'"
							[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
							[matTooltipClass]="'terminatedTooltip'"></mat-row>
					</mat-table>
				</div>
				<mat-paginator #paginators
					[pageSizeOptions]="[5, 10, 20, (selectedChildrenTableDataSource ? selectedChildrenTableDataSource.data.length > 100 ? selectedChildrenTableDataSource.data.length : 100 : 100)]"
					showFirstLastButtons aria-label="Select page of periodic elements"
					[hidden]="selectedChildrenTableDataSource?.filteredData?.length === 0">
				</mat-paginator>
			</mat-expansion-panel>
		</mat-accordion>

		<hr />

		<div class="text-center">
			<h2 *ngIf="chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0">Service Period:
				{{chosenEnrollmentPeriods[0].CODE}}</h2>
		</div>

		<hr />

		<div *ngIf="!isLoading">
			<form [formGroup]="form" (ngSubmit)="submit()" #enrollmentForm="ngForm">
				<div class="row">


					<div class="row">
						<div class="col-lg-6">
							<div class="row">
								<mat-form-field class="col-lg-12">
									<mat-label>
										Start Date
									</mat-label>
									<input matInput formControlName="startDate" [matDatepicker]="startDatePicker"
										(click)="startDatePicker.open()" startView="multi-year"
										[min]="startDateOptions.minDate" [max]="startDateOptions.maxDate"
										(dateChange)="startDateChange()">
									<mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #startDatePicker startView="multi-year"
										[startAt]="startDateOptions.startAt"></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
						<div class="col-lg-6">
							<div class="row">
								<mat-form-field class="col-lg-12">
									<mat-label>
										End Date
									</mat-label>
									<input matInput formControlName="endDate" [matDatepicker]="endDatePicker"
										(click)="endDatePicker.open()" startView="multi-year"
										[min]="endDateOptions.minDate" [max]="endDateOptions.maxDate"
										(dateChange)="endDateChange()">
									<mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
									<mat-datepicker #endDatePicker startView="multi-year"
										[startAt]="endDatePicker.startAt"></mat-datepicker>
								</mat-form-field>
							</div>
						</div>
					</div>

					<div class="row"
						*ngIf="selectedSchoolYear && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'R'">
						<div>* Regular Start/End Dates: 7/1/{{getCurrentYear(selectedSchoolYear)}} -
							8/31/{{getNextYear(selectedSchoolYear)}} (Start/End dates within enrollment
							and withdrawal date)
						</div>
					</div>
					<div class="row"
						*ngIf="selectedSchoolYear && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'S'">
						<div>* Summer Start Date: 5/15/{{getNextYear(selectedSchoolYear)}} -
							8/31/{{getNextYear(selectedSchoolYear)}} (Start date after withdrawal
							date)
						</div>
						<div>** Summer End Date: 5/15/{{getNextYear(selectedSchoolYear)}} -
							9/20/{{getNextYear(selectedSchoolYear)}} (No End Date restrictions)
						</div>
					</div>
					<div class="row"
						*ngIf="selectedSchoolYear && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'I'">
						<div>* Intersession Start Date: 7/1/{{getCurrentYear(selectedSchoolYear)}} -
							8/31/{{getNextYear(selectedSchoolYear)}} (Start date after enrollment
							date)
						</div>
						<div>** Intersession End Date: Start Date - (31 days after Start Date) (No End Date
							restrictions)
						</div>
					</div>

					<div class="row" class="warn-font-color italic"
						*ngIf="(startDateOptions.minDate >= startDateOptions.defaultMinDate || startDateOptions.maxDate <= startDateOptions.defaultMaxDate) && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE !== 'S' && startDateOptions.minDate < startDateOptions.maxDate">
						Valid Dates (Common School Enrollments): {{(restrictedDateOptions.minDate ?
						restrictedDateOptions.minDate
						: startDateOptions.minDate) | simpleDate}} {{restrictedDateOptions.minDate ? '(E)' : ''}} -
						{{(restrictedDateOptions.maxDate ? restrictedDateOptions.maxDate : startDateOptions.maxDate) |
						simpleDate}} {{restrictedDateOptions.maxDate ?
						'(Withdrawal/Termination/EoE)' : '(No Withdrawal Date)'}}
					</div>

					<div class="row" class="warn-font-color italic"
						*ngIf="(startDateOptions.minDate > startDateOptions.defaultMinDate) && chosenEnrollmentPeriods && chosenEnrollmentPeriods.length > 0 && chosenEnrollmentPeriods[0].CODE === 'S' && startDateOptions.minDate < startDateOptions.maxDate">
						Valid Dates (Common School Enrollments): On or after {{restrictedDateOptions.maxDate |
						simpleDate}}
						(W)
					</div>

					<div class="row" class="warn-font-color italic"
						*ngIf="startDateOptions.minDate > startDateOptions.maxDate">
						No valid dates available.
					</div>

					<div class="row" *ngIf="dateFlags.length > 0">
						<div>
							<div class="danger bold" *ngFor="let creationFlag of creationFlags">
								{{creationFlag.NAME | titlecase}}'s
								<span *ngIf="creationFlag.MSD_NUMBER.length > 0">({{creationFlag.MSD_NUMBER}})</span>
								{{creationFlag.TYPE}} date {{creationFlag.DATE | simpleDate}}
								makes them ineligible for School Year {{selectedSchoolYear}}.
							</div>
						</div>
					</div>

					<app-msg class="margin-left-sm" [msg]="errorMsg" *ngIf="errorMsg?.MSG"></app-msg>
				</div>
			</form>

			<mat-icon *ngIf="loadingChanges">
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>

			<hr />
		</div>
	</mat-card-content>
	<mat-card-actions class="inline">
		<button class="margin-bottom-xs" type="submit" *ngIf="!isSubmitting" mat-raised-button color="primary"
			(click)="confirmPopup()"
			[disabled]="isSubmitting || (msg && msg.SUCCESS!) || (errorMsg && !errorMsg.SUCCESS)">
			Update
		</button>

		<button type="button" mat-icon-button *ngIf="isSubmitting">
			<mat-icon>
				<mat-spinner diameter="20"> </mat-spinner>
			</mat-icon>
		</button>
		<app-msg class="margin-left-sm" [msg]="msg" *ngIf="msg?.MSG"></app-msg>
	</mat-card-actions>
</mat-card>